import { SERVER_API_URL } from "../app.constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class PersonService {
    private resourceUrl = SERVER_API_URL + 'api/persons';

    constructor(
        private http: HttpClient) {
    }

    getPersons(includeInactive = false): Observable<HttpResponse<Nema.Crew.Model.Person[]>> {
        return this.http
            .get<Nema.Crew.Model.Person[]>(`${this.resourceUrl}?includeInactive=${includeInactive}`, { observe: 'response' })
            .map((res: HttpResponse<Nema.Crew.Model.Person[]>) => this.convertArrayResponse(res));
    }

    getPersonsHavingNoActivityOnDay(day: Date, includeInactive = false): Observable<HttpResponse<Nema.Crew.Model.Person[]>> {
        return this.http
            .get<Nema.Crew.Model.Person[]>(`${this.resourceUrl}/no-activity?day=${day.toISOString()}&includeInactive=${includeInactive}`, { observe: 'response' })
            .map((res: HttpResponse<Nema.Crew.Model.Person[]>) => this.convertArrayResponse(res));
    }

    //private _convertResponse(res: HttpResponse<PersonDto>): HttpResponse<PersonDto> {
    //    const body: PersonDto = this.convertItemFromServer(res.body);
    //    return res.clone({ body });
    //}

    private convertArrayResponse(res: HttpResponse<Nema.Crew.Model.Person[]>): HttpResponse<Nema.Crew.Model.Person[]> {
        const jsonResponse: Nema.Crew.Model.Person[] = res.body;
        const body: Nema.Crew.Model.Person[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }

        return res.clone({ body });
    }

    private convertItemFromServer(person: Nema.Crew.Model.Person): Nema.Crew.Model.Person{
        const copy: Nema.Crew.Model.Person = Object.assign({}, person);
        return copy;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/person.service.ts